import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

const emptyCustomer = { first_name: '', last_name: '', email: '', phone: '', address: '', city: '', state: '', zip: '', drivers_license: '', date_of_birth: '', notes: '' };

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyCustomer);
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);

  const load = () => {
    setLoading(true);
    api.getCustomers().then(c => {
      const list = Array.isArray(c) ? c : [];
      setCustomers(list); setFiltered(list); setLoading(false);
    });
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const openAdd = () => { setEditing(null); setForm(emptyCustomer); setModal(true); };
  const openEdit = (c) => { setEditing(c.id); setForm({ ...emptyCustomer, ...c }); setModal(true); };

  const deleteCustomer = async (id, name, dealCount) => {
    const msg = dealCount > 0 
      ? 'WARNING: ' + name + ' has ' + dealCount + ' deal(s). Deleting this customer will also delete all their deals and payment history. This cannot be undone. Are you sure?'
      : 'Delete ' + name + '? This cannot be undone.';
    if (!window.confirm(msg)) return;
    await api.deleteCustomer(id);
    load();
  };

  const save = async () => {
    setSaving(true);
    if (editing) await api.updateCustomer(editing, form);
    else await api.saveCustomer(form);
    setSaving(false);
    setModal(false);
    load();
  };

  const search = (q) => {
    setFiltered(customers.filter(c =>
      `${c.first_name} ${c.last_name} ${c.phone || ''} ${c.email || ''}`.toLowerCase().includes(q.toLowerCase())
    ));
  };

  return (
    <div>
      <div className="page-header">
        <h1>Customer <span>Database</span></h1>
        <button className="btn-red" onClick={openAdd}>+ Add Customer</button>
      </div>
      <input className="search-input" type="text" placeholder="Search by name, phone, email..." onChange={e => search(e.target.value)} />
      {loading ? <div className="loading">Loading...</div> : (
        <table className="data-table">
          <thead><tr>
            <th>Customer</th><th>Phone</th><th>Email</th><th>Location</th><th>Deals</th><th>Actions</th>
          </tr></thead>
          <tbody>
            {filtered.map(c => (
              <tr key={c.id}>
                <td><strong>{c.first_name} {c.last_name}</strong></td>
                <td style={{ color: '#888' }}>{c.phone || '—'}</td>
                <td style={{ color: '#888' }}>{c.email || '—'}</td>
                <td style={{ color: '#888' }}>{c.city}{c.state ? `, ${c.state}` : ''}</td>
                <td style={{ color: '#cc0000', fontWeight: 700 }}>{c.deal_count || 0}</td>
                <td style={{display:"flex",gap:4}}><button className="btn-ghost" onClick={() => openEdit(c)}>Edit</button><button className="btn-ghost" onClick={() => deleteCustomer(c.id, c.first_name+" "+c.last_name, c.deal_count)} style={{borderColor:"#ff4444",color:"#ff4444"}}>Delete</button></td>
              </tr>
            ))}
            {!filtered.length && <tr><td colSpan={6}><div className="empty-state"><div className="icon">👥</div><p>No customers yet.</p></div></td></tr>}
          </tbody>
        </table>
      )}

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <h2>{editing ? 'Edit' : 'Add'} Customer</h2>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group"><label>First Name</label><input value={form.first_name} onChange={e => set('first_name', e.target.value)} placeholder="John" /></div>
                <div className="form-group"><label>Last Name</label><input value={form.last_name} onChange={e => set('last_name', e.target.value)} placeholder="Smith" /></div>
                <div className="form-group"><label>Phone</label><input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="(555) 000-0000" /></div>
                <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="john@email.com" /></div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}><label>Address</label><input value={form.address} onChange={e => set('address', e.target.value)} placeholder="123 Main St" /></div>
                <div className="form-group"><label>City</label><input value={form.city} onChange={e => set('city', e.target.value)} placeholder="Summerville" /></div>
                <div className="form-group"><label>State</label><input value={form.state} onChange={e => set('state', e.target.value)} placeholder="SC" /></div>
                <div className="form-group"><label>ZIP</label><input value={form.zip} onChange={e => set('zip', e.target.value)} placeholder="29483" /></div>
                <div className="form-group"><label>Driver's License</label><input value={form.drivers_license} onChange={e => set('drivers_license', e.target.value)} /></div>
                <div className="form-group"><label>Date of Birth</label><input type="date" value={form.date_of_birth} onChange={e => set('date_of_birth', e.target.value)} /></div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}><label>Notes</label><textarea value={form.notes} onChange={e => set('notes', e.target.value)} placeholder="Any notes about this customer..." /></div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-red" onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save Customer'}</button>
              <button className="btn-outline" onClick={() => setModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
